import moment from "moment";
import { GET_SEDES } from 'store/store-constants';
import { store } from 'store/main-store';

export default {
    numberWithDots: stringReal => {
        var toInt = parseInt(stringReal);
        var roundedValue = Math.round(toInt/100000)*100000;
        return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    numberWithoutDots: stringReal => {
        var roundedValue = parseInt(stringReal);
        // var roundedValue = Math.round(toInt/100000)*100000;
        return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    numberWithDotsFront: stringReal => {
        var toInt = parseInt(stringReal);
        var roundedValue = Math.round(toInt/100000)*100000;
        return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    tiposDoc() {
        return [
            {
                value: "cedula",
                text: "Cedula"
            },
            {
                value: "tarjeta_identidad",
                text: "Tarjeta de identidad"
            },
            {
                value: "pasaporte",
                text: "Pasaporte"
            },
            {
                value: "nit",
                text: "NIT"
            }
        ];
    },
    get_combustible(code_combustible) {
        switch (code_combustible) {
            case "GSL":
                return "Gasolina";
                break;
            case "DSL":
                return "Diesel";
                break;
            case "ELT":
                return "Electrico";
                break;
            case "HBD":
                return "Híbrido";
                break;
            default:
                return code_combustible;
        }
    },
    get_tipo_caja(code_caja) {
        switch (code_caja) {
            case "AT":
                return "Automática";
                break;
            case "MT":
                return "Mecánica";
                break;
            case "TP":
                return "Triptonic";
                break;
        }
    },
    numberWithDotsNotRounded: stringReal => {
        var toInt = parseInt(stringReal);
        return toInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatFasecolda: fasecolda => {
        var stringReal = fasecolda + "000";
        var toInt = parseInt(stringReal);
        return toInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    format_create_date: date => {
        return moment(date).format("DD-MM-YYYY");
    },
    bytesToSize: bytes => {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes == 0) return "0 Byte";
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    uploadProfileImage: (file, onUploadProgress) => {
        let formData = new FormData();
        formData.append("file", file);
        return axios.post("/ajax/upload_image_profile", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    },
    getVehiculos(inventario) {
        const vehiculos = inventario.map(item => {
            let vehiculo = {};
            vehiculo.datos = {};
            vehiculo.id = item._id;
            vehiculo.linea = item.modelorel.lineas;
            vehiculo.marca = item.modelorel.marca;
            vehiculo.modelo = item.modelorel.modelo;
            vehiculo.main_image = item.main_image;
            vehiculo.marca_linea_modelo = `${vehiculo.marca.name} ${vehiculo.linea.name} ${vehiculo.modelo}`;
            vehiculo.datos.kilometraje = item.fichatecnica.kilometraje;
            vehiculo.datos.precio = item.fichatecnica.precio_publicacion;
            vehiculo.datos.combustible =
                item.modelorel.version.meta_keys.combustible;
            vehiculo.datos.clindraje = item.modelorel.version.meta_keys.clindraje;
            vehiculo.datos.ubicacion_name = item.fichatecnica.datos_vehiculo.transito_name;
            return vehiculo;
        });
        return vehiculos;
    },
    getBuscadorUrl(baseurl, marca = "", modelo = "", linea = "", caja = "", price = []) {
        var newUrl = new URL('/compra_de_usados', baseurl);
        var params = new URLSearchParams(newUrl.search);

        if (!!marca) params.set('marca', marca);

        if (!!modelo) params.set('modelo', modelo);

        if (!!linea) params.set('linea', linea);

        if (!!caja) params.set('caja', caja);

        if (!!price) params.set('precio', price[0]+":"+price[1]);

        return `${newUrl}?${params}`;
    },
    get_sedes() {
        axios.get("/ajax/get_sedes").then(response => {
            const parsingSedes = _.orderBy(
                response.data.sedes,
                ["nombre"],
                ["asc"]
            );
            store.commit(GET_SEDES, parsingSedes);
        });
    }
};
